import { COMBO_MASTER } from './Combo.Master';
import { COMBO_ON } from './Combo.On';
import { COMBO_PLUS } from './Combo.Plus';

const Combos = {
  ON: COMBO_ON,
  PLUS: COMBO_PLUS,
  MASTER: COMBO_MASTER,
};

export const CombosPermissions = [...COMBO_ON, ...COMBO_PLUS, ...COMBO_MASTER];

export default Combos;
